import { CarbonSourceType } from "@shared/api/transactions/types"

type CarbonSourceTitleTypes = "common" | "biogenic" | "fossil"

export const carbonSourceTypeToTitleTypeMap: Record<
	CarbonSourceType,
	CarbonSourceTitleTypes
> = {
	[CarbonSourceType.All]: "common",
	[CarbonSourceType.Biogenic]: "biogenic",
	[CarbonSourceType.Fossil]: "fossil",
}
